import Swiper, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper';


Swiper.use([Navigation, Pagination, EffectFade, Autoplay]);


export const initSwipers = function() {

   console.log("initSwipers")

   let slideshowSwiper  = new Swiper('.slideshow-swiper', {
        spaceBetween: 0,
        grabCursor: true,
        slidesPerView: 1,
        speed: 1000,
        effect: "fade",
        loop: true,
        autoplay: {
            delay: 6000,
        },
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: ".swiper-pagination"
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });


} 